<template>
  <v-container fluid>
    <data_table
      :displayname="'Drill Pipe'"
      :loader="get_data_load"
      :options="false"
      :headers="headers"
      :items="ODP_data.Tubular"
      :search_text="search_text"
      :getPDF_func="$getPDFglobal"
      :pdf_params="pdfparams"
      :type="'Tubular'"
      :defaultSort="'Returned_Date'"
    />
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
import data_table from '@/components/data_table.vue'
export default {
  name: 'dp',
  components: { data_table },
  data () {
    return {
      pdfparams: [{ Tubular: '/getdpPDF' }, 'Order_No'],
      search_text: 'Search (Order No, Ref etc..)',
      search: '',
      headers: [ 
        { text: 'Order No', align: 'start', sortable: true, value: 'Order_No' },
        { text: 'Returned From', value: 'Returned_From' },
        { text: 'Returned Date', value: 'Returned_Date' },
        { text: 'Ref', value: 'Ref' },
        { text: 'Quantity', value: 'Quantity' },
        { text: 'Item No', value: 'Item_No' },
        { text: 'Weight', value: 'Weight' },
        { text: 'Grade', value: 'Grade' },
        { text: 'Connection', value: 'Connection' },
        { text: 'Spec', value: 'Spec' },
        { text: 'PDF', value: 'action', sortable: false }
      ],
      ODP_data: { Tubular: [], BHA: [] }
    }
  },
  computed: {
    ...mapGetters(['getUsername'])
  },
  mounted () {
    this.$initialDataLoad(this.$route.meta.backendRoutes, { username: this.$store.getters.getUsername }, 'Returned_Date')
  },
}
</script>

<style>
</style>
